export var TeamTimeoutTypes = ["full", "short", "commercial"];

export var OfficialTimeoutTypes = ["officials", "commercial", "media"];
